<p-autoComplete
    [(ngModel)]="selectedValues"
    [suggestions]="filteredValues"
    (completeMethod)="filter($event)"
    [minLength]="1"
    [multiple]="true"
    inputStyleClass="form-control"
    styleClass="width-percent-100"></p-autoComplete>
